import { useState, useContext, useEffect } from 'react'
import { useRouter } from 'next/router'

import {
  GlobalStateContext,
  GlobalDispatchContext,
} from 'context/GlobalContextProvider'
import accountLogin from 'actions/account/login'
import graphqlQuery from 'helpers/graphqlQuery'
import LOGIN_USER from 'graphql/mutations/loginUser.query'
import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'

import CollectionsLayout from 'components/CollectionsLayout'
import Link from 'components/Link'

import s from './index.module.css'

// TODO: Setup proptypes
function Login(props) {
  const { site } = props
  const router = useRouter()
  const { account } = useContext(GlobalStateContext)
  const dispatch = useContext(GlobalDispatchContext)
  const [error, setError] = useState(null)
  const [fieldValues, setFieldValues] = useState({
    email: '',
    password: '',
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    const resp = await graphqlQuery(LOGIN_USER, 'WP_ROOT', {
      input: {
        clientMutationId: 'LoginUser',
        username: fieldValues.email,
        password: fieldValues.password,
      },
    })

    if (resp.error) setError(resp.error)

    if (resp.data && resp.data.login) dispatch(accountLogin(resp.data.login))
  }

  useEffect(() => {
    if (account.loggedIn) router.push(`${site}/collections`)
  }, [account])

  const handleAttrChange = (attr, val) => {
    setFieldValues((cur) => ({
      ...cur,
      [attr]: val,
    }))
  }

  return (
    <CollectionsLayout {...props}>
      <h1>Login</h1>
      <p className={s.intro}>Welcome back</p>
      <form onSubmit={handleSubmit} className={s.form}>
        {error && <div className={s.error}>{error}</div>}
        <input
          type="email"
          value={fieldValues.email}
          placeholder="Email"
          className={s.input}
          onChange={(e) => handleAttrChange('email', e.target.value)}
        />
        <input
          type="password"
          value={fieldValues.password}
          placeholder="Password"
          className={s.input}
          onChange={(e) => handleAttrChange('password', e.target.value)}
        />
        <input type="submit" value="Submit" className={s.button} />
      </form>
      <p className={s.text}>
        Forgotten your password?{' '}
        <Link href="collections/reset" type="Collections" className={s.button}>
          Password reset
        </Link>
      </p>
      <p className={s.text}>
        Need an account?{' '}
        <Link href="collections/signup" type="Collections" className={s.button}>
          Create account
        </Link>
      </p>
    </CollectionsLayout>
  )
}

Login.propTypes = {}
Login.defaultProps = {}

export default Login

export async function getStaticProps({ params }) {
  return {
    props: {
      ...params,
    },
    revalidate: 60 * 60,
  }
}

export async function getStaticPaths() {
  const sites = await getSitesForStaticPaths()

  const paths = sites.map((site) => ({
    params: {
      site: site,
    },
  }))

  return {
    paths,
    fallback: false,
  }
}
